import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Card,
  Dropdown,
  notification,
  Space,
  Table,
  Modal,
  Row,
  Input,
  Form,
  Col,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import axiosInstance from "../../utils/axios";
import { useLoader } from "../../context/LoaderContext";
import {
  getAffaires,
  getListMentionApprenants,
  getListResultatApprenant,
} from "../../api/geoprod";
import dayjs from "dayjs";
import GlobalContext from "../../context/GlobalContext";
import ModalUploadPVCertifs from "./LancementSessionFormationNonHomologuee/Modals/ModalUploadPVCertifs";

const CoursSession = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setIsLoading, setShowingPreview } = useLoader();
  const [dataSource, setDataSource] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [demandeurs, setDemandeurs] = useState([]);
  const [confirmAbandonVisible, setConfirmAbandonVisible] = useState(false);
  const [apprenantToRemove, setApprenantToRemove] = useState(null);
  const [sessionToRemoveFrom, setSessionToRemoveFrom] = useState(null);
  const [openModal, setOpenModal] = useState([]);
  const [pv, setPv] = useState("");

  const { setCurrentStep } = useContext(GlobalContext);

  const fetchApprenants = async (idFormation) => {
    try {
      const res = await axiosInstance.get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/list_apprenant?id_affaire=2025-04-07 09:03:07.098`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      );
      return res?.data?.message?.Data || [];
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Impossible de récupérer les apprenants.",
      });
      return [];
    }
  };

  const fetchDemandeurs = async (idFormation) => {
    try {
      const res = await axiosInstance.get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/list_apprenant?id_formation=128`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      );
      return res?.data?.message?.Data || [];
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Impossible de récupérer les demandeurs.",
      });
      return [];
    }
  };

  const addApprenantsToSession = async (id_session, ids) => {
    try {
      await axiosInstance.post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/add_apprenant_to_session`,
        {
          list_apprenants: ids,
          id_session: "2025-04-07 09:03:07.098",
        },
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      );
      notification.success({
        message: "Succès",
        description: "Participants ajoutés avec succès.",
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de l'ajout de participants.",
      });
    }
  };

  const deleteApprenantSession = async (idFormation, idApprenant) => {
    try {
      await axiosInstance.delete(
        `${import.meta.env.VITE_APP_GEOPROD_API}/delete_apprenant_session`,
        {
          data: {
            apprenants: [
              {
                id_apprenant: idApprenant,
                id_formation: 116,
              },
            ],
          },
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      );
      notification.success({
        message: "Succès",
        description: "Participant supprimé avec succès.",
      });
    } catch (error) {
      notification.success({
        message: "Succès",
        description: "Participant supprimé avec succès.",
      });
    }
  };

  const handleExpand = async (expanded, record) => {
    if (expanded) {
      const apprenants = await fetchApprenants(record.id_formation);
      setExpandedRows((prev) => ({ ...prev, [record.key]: apprenants }));
    }
  };

  const handleOpenModal = async (session) => {
    const demandeursData = await fetchDemandeurs(session.id_formation);
    setSelectedSession(session);
    setDemandeurs(demandeursData);
    setSelectedRowKeys([]);
    setModalVisible(true);
  };

  const handleAddParticipant = async () => {
    const ids = selectedRowKeys.map((id) => {
      const participant = demandeurs.find((p) => p.id === id);
      return participant?.id;
    });

    await addApprenantsToSession(selectedSession.id_formation, ids);

    setExpandedRows((prev) => ({
      ...prev,
      [selectedSession.key]: [
        ...(prev[selectedSession.key] || []),
        ...demandeurs.filter((d) => ids.includes(d.id)),
      ],
    }));
    setModalVisible(false);
    setSelectedRowKeys([]);
  };

  const handleRemoveParticipant = (participant, session) => {
    setApprenantToRemove(participant);
    setSessionToRemoveFrom(session);
    setConfirmAbandonVisible(true);
  };

  const confirmRemove = async () => {
    if (apprenantToRemove && sessionToRemoveFrom) {
      await deleteApprenantSession(
        sessionToRemoveFrom.id_formation,
        apprenantToRemove.id
      );
      setExpandedRows((prev) => ({
        ...prev,
        [sessionToRemoveFrom.key]: prev[sessionToRemoveFrom.key].filter(
          (p) => p.id !== apprenantToRemove.id
        ),
      }));
    }
    setConfirmAbandonVisible(false);
    setApprenantToRemove(null);
    setSessionToRemoveFrom(null);
  };
  const extractDateFromFileName = (fileName) => {
    const match = fileName.match(/\d{8}/);
    if (match) {
      const dateStr = match[0];
      return new Date(
        parseInt(dateStr.slice(0, 4)),
        parseInt(dateStr.slice(4, 6)) - 1,
        parseInt(dateStr.slice(6, 8))
      );
    }
    return new Date(0);
  };
  const columns = [
    {
      title: t("Numéro d'enregistrement"),
      key: "Numéro d'enregistrement",
      render: (_, record) =>
        record?.registration_number
          ? record?.registration_number
          : t("Non renseigné"),
    },
    {
      title: t("Dénomination"),
      key: "dénomination",
      render: (_, record) =>
        record?.establishment_data_commercial_name ||
        record?.establishment_data_official_name ||
        record?.legal_entity_official_name,
    },
    {
      title: t("Directeur"),
      key: "directeur",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" &&
        record?.establishment_director_data_last_name
          ? record?.establishment_director_data_last_name +
            " " +
            record?.establishment_director_data_first_name
          : record?.establishment_director_data_last_name_fr +
            " " +
            record?.establishment_director_data_first_name_fr,
    },
    {
      title: t("Gouvernorat"),
      key: "gouvernorat",
      render: (_, record) => record.establishment_data_governorate,
    },
    {
      title: t("Délégation"),
      key: "délégation",
      render: (_, record) => record.establishment_data_delegation,
    },
    {
      title: t("Nature formation"),
      key: "nature formation",
      render: (_, record) => record?.establishment_data_training_type,
    },
    {
      title: t("Spécialité formation"),
      key: "specialite",
      render: (_, record) => record?.specialite,
    },

    {
      title: t("Date de début de la session de formation"),
      key: "date_debut",
      render: (_, record) =>
        dayjs(record?.date_debut_session).format("DD/MM/YYYY"),
    },
    {
      title: t("Date de fin de la session de formation"),
      key: "date_fin",
      render: (_, record) =>
        dayjs(record?.date_fin_session).format("DD/MM/YYYY"),
    },

    {
      title: t("Statut"),
      key: "statut",
      render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: record?.etat_background,
              color: record?.etat_color,
            }}
          >
            {t(record?.etat)}
          </span>
        );
      },
    },
    {
      title: t("Type"),
      key: "statut",
      render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: record?.etat_background,
              color: record?.etat_color,
            }}
          >
            {t(record.contrat_type)}
          </span>
        );
      },
    },
    {
      title: t("Créateur de la demande"),
      key: "Créateur de la demande",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.nom_createur_ar
          ? record.nom_createur_ar + " " + record?.prenom_createur_ar
          : record?.nom_createur + " " + record?.prenom_createur,
    },
    {
      title: t("Date de soumission"),
      key: "Date de soumission",
      render: (_, record) =>
        record?.affaire_date_creation
          ? dayjs(record?.affaire_date_creation).format("DD/MM/YYYY HH:MM:ss")
          : t("Non renseigné"),
    },
    {
      title: t("Actions"),
      key: "Actions",
      render: (_, record) => (
        <Space>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Button
                      size="small"
                      block
                      onClick={() => {
                        sessionStorage.removeItem("currentStep");
                        setCurrentStep(0);
                        sessionStorage.setItem("consulter", true);
                        setIsLoading(true);
                        setShowingPreview(true);
                        axiosInstance
                          .get(
                            import.meta.env.VITE_APP_GEOPROD_API +
                              "/get_info_specifique/" +
                              record?.affaire_id,
                            {
                              headers: {
                                Idsession: JSON.parse(
                                  localStorage.getItem("-x-token-user")
                                )?.Acces_Token,
                              },
                            }
                          )
                          .then(async (res) => {
                            setIsLoading(false);
                             sessionStorage.setItem("demande", true);
                            sessionStorage.setItem("id_session_formation_homologuee", record?.affaire_id);

                            sessionStorage.setItem(
                              "globalData",
                              JSON.stringify(res?.data?.response?.data)
                            );
                            if (
                              record?.affaire_id_contrat ===
                              import.meta.env
                                .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE
                            ) {
                              navigate(
                                "/formations/lancementSessionFormationHomologuee",
                                {
                                  state: {
                                    id_session_formation_homologuee:
                                      record.affaire_id,
                                  },
                                }
                              );
                            } else if (
                              record?.affaire_id_contrat ===
                              import.meta.env
                                .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE
                            ) {
                              navigate(
                                "/formations/lancementSessionFormationNonHomologuee",
                                {
                                  state: {
                                    id_session_formation_non_homologuee:
                                      record.affaire_id,
                                    typesession: "non_homologuee",
                                    id_formation: record?.id_formation_session,
                                  },
                                }
                              );
                            } else {
                              navigate(
                                "/formations/lancementSessionFormationContinue",
                                {
                                  state: {
                                    id_session_formation_continue:
                                      record.affaire_id,
                                    typesession: "continue",
                                    id_formation: record?.id_formation_session,
                                  },
                                }
                              );
                            }
                          })
                          .catch(() => {
                            setIsLoading(false);
                            notification.error({
                              message: t("Erreur"),
                              description:
                                "Une erreur a été rencontré lors de chargement de formulaire de l'epf existant",
                              duration: 0,
                            });
                          });
                      }}
                    >
                      {t("Consulter la demande")}
                    </Button>
                  ),
                },
                {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={
                        record?.id_etat_dossier_md5 ===
                        import.meta.env
                          .VITE_APP_ID_STATUS_BLOQUEE_SESSION_FORMATION_HOMOLOGUEE
                      }
                      onClick={() => {
                        // debugger
                        navigate(
                          "/sessionFormationHomologuee/apprenants/" +
                            record?.real_id_affaire,
                          {
                            state: {
                              idSession: record?.real_id_affaire,
                              id_session_formation:
                                record?.id_formation_session,
                              check_disabled_btn_add_apprenant:
                                record?.id_etat_dossier ===
                                parseInt(
                                  import.meta.env
                                    .VITE_APP_ID_STATUS_REAL_ID_INSCRIPTION_POSSIBLE_CREATION_SESSION_FORMATION_HOMOLOGUEE
                                )
                                  ? true
                                  : false,
                              ligne_produit: record?.affaire_id_contrat,
                            },
                          }
                        );
                      }}
                    >
                      {t("Liste des apprenants")}
                    </Button>
                  ),
                },

                  record?.affaire_id_contrat ===
                    import.meta.env
                      .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE && {
                  label: (
                    <Button
                      disabled={
                        record?.id_etat_dossier_md5 ===
                        import.meta.env
                          .VITE_APP_ID_STATUS_BLOQUEE_SESSION_FORMATION_HOMOLOGUEE
                      }
                      size="small"
                      block
                      onClick={() => {
                        // debugger
                        navigate("/sessionFormationHomologuee/getAllExams", {
                          state: {
                            id_affaire: record?.real_id_affaire,
                            id_status: record?.id_etat_dossier_md5,
                          },
                        });
                      }}
                    >
                      {t("Liste des examens et des rattrapages")}
                    </Button>
                  ),
                },

                {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={
                        record?.id_etat_dossier_md5 !==
                        import.meta.env
                          .VITE_APP_ID_STATUS_EN_ATTENTE_CLOTURE_SESSION_FORMATION_HOMOLOGUEE
                      }
                      onClick={() => {
                        setIsLoading(false);

                        getListResultatApprenant()
                          .then((resResultats) => {
                            const resultatsList =
                              resResultats?.list?.map((item) => ({
                                label: item?.libelle,
                                value: item?.id,
                              })) || [];

                            getListMentionApprenants()
                              .then((resMentions) => {
                                const mentionsList =
                                  resMentions?.list?.map((item) => ({
                                    label: item?.libelle,
                                    value: item?.id,
                                  })) || [];

                                const mergedData = {
                                  ...resultatsList,
                                  ...mentionsList,
                                };

                                sessionStorage.setItem(
                                  "globalData",
                                  JSON.stringify(mergedData)
                                );

                                navigate("/sessionFormation/addMention", {
                                  state: {
                                    id_affaire: record?.real_id_affaire,
                                    mentionsList: mentionsList,
                                    resultatsList: resultatsList,
                                    modificationMention : true
                                  },
                                });
                              })

                              .catch((error) => {
                                notification.error({
                                  message: t("Erreur"),
                                  description: t(error?.data?.message),
                                  duration: 0,
                                });
                                setIsLoading(false);
                              });
                          })

                          .catch((error) => {
                            notification.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                            setIsLoading(false);
                          });
                      }}
                    >
                      {t("Clôturer la session")}
                    </Button>
                  ),
                },

                 {
                  label: (
                    <Button
                      size="small"
                      block
                      disabled={
                     ![
                        import.meta.env.VITE_APP_ID_STATUS_CLOTURE_REFUSEE_SESSION_FORMATION_HOMOLOGUEE,
                        import.meta.env.VITE_APP_ID_STATUS_CLOTURE_VALIDEE_SESSION_FORMATION_HOMOLOGUEE,
                        import.meta.env.VITE_APP_ID_STATUS_EN_ATTENTE_VALIDATION_CLOTURE_SESSION_FORMATION_HOMOLOGUEE
                      ].includes(record?.id_etat_dossier_md5)
                      }
                      onClick={() => {
                        setIsLoading(false);

                        getListResultatApprenant()
                          .then((resResultats) => {
                            const resultatsList =
                              resResultats?.list?.map((item) => ({
                                label: item?.libelle,
                                value: item?.id,
                              })) || [];
                            // setResultatsList(dataResult);

                            getListMentionApprenants()
                              .then((resMentions) => {
                                const mentionsList =
                                  resMentions?.list?.map((item) => ({
                                    label: item?.libelle,
                                    value: item?.id,
                                  })) || [];

                                const mergedData = {
                                  ...resultatsList,
                                  ...mentionsList,
                                };

                                sessionStorage.setItem(
                                  "globalData",
                                  JSON.stringify(mergedData)
                                );

                                navigate("/sessionFormation/addMention", {
                                  state: {
                                    id_affaire: record?.real_id_affaire,
                                    mentionsList: mentionsList,
                                    resultatsList: resultatsList,
                                    consulterCloture : true
                                  },
                                });
                              })

                              .catch((error) => {
                                notification.error({
                                  message: t("Erreur"),
                                  description: t(error?.data?.message),
                                  duration: 0,
                                });
                                setIsLoading(false);
                              });
                          })

                          .catch((error) => {
                            notification.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                            setIsLoading(false);
                          });
                      }}
                    >
                      {t("Consulter la cloture de la session")}
                    </Button>
                  ),
                },

                record?.affaire_id_contrat !==
                  import.meta.env
                    .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE &&
                  (record?.id_etat_dossier_md5 ===
                    import.meta.env
                      .VITE_APP_ID_STATUS_EN_ATTENTE_DEPOT_PV_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE ||
                    record?.id_etat_dossier_md5 ===
                      import.meta.env
                        .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE) && {
                    label: (
                      <Button
                        size="small"
                        block
                        onClick={() => {
                          setIsLoading(true);
                          axiosInstance
                            .get(
                              `${
                                import.meta.env.VITE_APP_GEOPROD_API
                              }/list_apprenant?id_affaire=${record.affaire_id}`,
                              {
                                headers: {
                                  Idsession: JSON.parse(
                                    localStorage.getItem("-x-token-user")
                                  )?.Acces_Token,
                                },
                              }
                            )
                            .then((resultat) => {
                              axiosInstance
                                .get(
                                  `${
                                    import.meta.env.VITE_APP_GEOPROD_API
                                  }/v0/load_list_document_affaire/${
                                    record?.affaire_id
                                  }`,
                                  {
                                    headers: {
                                      Idsession: JSON.parse(
                                        localStorage.getItem("-x-token-user")
                                      )?.Acces_Token,
                                    },
                                  }
                                )
                                .then((res) => {
                                  const files = res?.data?.find(
                                    (e) =>
                                      e.md5_id ===
                                      import.meta.env
                                        .VITE_APP_ID_PORTE_DOCUMENT_PV_SESSION_NON_HOMOLOGUEE_CONTINUE
                                  )?.files;

                                  if (files?.length > 0) {
                                    const sortedFiles = [...files].sort(
                                      (a, b) => {
                                        const dateA = extractDateFromFileName(
                                          a.name
                                        );
                                        const dateB = extractDateFromFileName(
                                          b.name
                                        );
                                        return dateB - dateA;
                                      }
                                    );

                                    const latestFile = sortedFiles[0];
                                    const pv = latestFile?.url_file || null;
                                    setPv(pv);
                                    setOpenModal({
                                      data: resultat?.data?.message?.Data,
                                      id_affaire: record?.affaire_id,
                                      etat_affaire: record?.id_etat_dossier_md5,
                                    });
                                    setIsLoading(false);
                                    sessionStorage.setItem(
                                      "id_affaire_to_upload_docs_session",
                                      record.affaire_id
                                    );
                                    sessionStorage.setItem(
                                      "id_formation_apprenants",
                                      record.id_formation_session
                                    );
                                  }
                                });
                              // if (
                              //   res.data.message.Data.some(
                              //     (elem) => elem.id_statut_apprenant === 5
                              //   )
                              // ) {

                              // }
                              // else{
                              //   setIsLoading(false)
                              //   notification.info({
                              //     description:"Tous les diplomes des particiapnats sont déja ajoutés."
                              //   })
                              // }
                            })
                            .catch(() => {
                              setIsLoading(false);
                            });
                        }}
                      >
                        {t("Dépot Pv/certifs")}
                      </Button>
                    ),
                  },
              ],
            }}
            trigger={["click"]}
          >
            <span style={{ cursor: "pointer" }}>
              <Space>
                {t("Liste")}
                <DownOutlined />
              </Space>
            </span>
          </Dropdown>
        </Space>
      ),
    },
  ];

  async function fetchData() {
    setIsLoading(true);
    try {
      const data = await getAffaires({
        id_user: JSON.parse(localStorage.getItem("-x-token-user")).id_user,
        id_entreprise: JSON.parse(localStorage.getItem("-x-token-user")).user
          .entreprise_id,
        filters: {
          contrat: [
            import.meta.env
              .VITE_APP_REAL_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_REAL_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_REAL_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_CONTINUE,
          ],
          status: [
            import.meta.env
              .VITE_APP_ID_STATUS_ACCEPTEE_CREATION_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_INSCRIPTION_POSSIBLE_CREATION_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_ACCEPTEE_AUTOMATIQUEMENT_CREATION_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_VALIDEE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE_ET_CONINUE,
            import.meta.env
              .VITE_APP_ID_STATUS_SESSION_HOMOLOGUEE_EN_ATTENTE_VALIDATION_NOTE,
            import.meta.env
              .VITE_APP_ID_STATUS_SESSION_HOMOLOGUEE_STATUS_VALIDER_NOTE,
            import.meta.env
              .VITE_APP_ID_STATUS_SESSION_HOMOLOGUEE_STATUS_REFUSER_NOTE,
            import.meta.env
              .VITE_APP_ID_STATUS_BLOQUEE_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_EN_ATTENTE_CLOTURE_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env.VITE_APP_ID_STATUS_CLOTURE_REFUSEE_SESSION_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_EN_ATTENTE_VALIDATION_CLOTURE_SESSION_FORMATION_HOMOLOGUEE,

            import.meta.env
              .VITE_APP_ID_STATUS_SESSION_ACCEPTEE_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE,
            import.meta.env
              .VITE_APP_ID_STATUS_EN_ATTENTE_DEPOT_PV_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE,
            import.meta.env
              .VITE_APP_ID_STATUS_PV_AJOUTE_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE,
            import.meta.env
              .VITE_APP_ID_STATUS_COMPLEMENT_DOSSIER_SESSION_FORMATION_NON_HOMOLOGUEE_CONTINUE,

               import.meta.env
              .VITE_APP_ID_STATUS_EN_ATTENTE_DEPOT_CALENDRIER_EXAMEN_RATTRAPAGE_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_EN_ATTENTE_VALIDATION_CALENDRIER_EXAMEN_RATTRAPAGE_FORMATION_HOMOLOGUEE,
            import.meta.env
              .VITE_APP_ID_STATUS_CALENDRIER_EXAMEN_RATTRAPAGE_VALIDE_FORMATION_HOMOLOGUEE,

                      import.meta.env
              .VITE_APP_ID_STATUS_CALENDRIER_EXAMEN_RATTRAPAGE_REFUSE_FORMATION_HOMOLOGUEE,

              
                      import.meta.env
              .VITE_APP_ID_STATUS_CALENDRIER_EXAMEN_RATTRAPAGE_REFUSE_FORMATION_HOMOLOGUEE,
          ],
          excludedStatus: [],
        },
        historique: false,
      });
      // Extract the ternary operation into a variable
      let filteredData;

      // if (typedemande === "taches") {
      //   filteredData = data?.aaData.filter(
      //     (elem) =>
      //       elem?.createur_id_md5 ===
      //       JSON.parse(localStorage.getItem("-x-token-user"))?.id_user
      //   );
      // } else if (typedemande !== "historique") {
      //   filteredData = data?.aaData?.filter(
      //     (elem) =>
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON_EPF_EXISTANT &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON_AVEC_VALIDATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON_SANS_VALIDATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_VALIDER_EPF &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_VALIDER_EPF_EXIST &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env
      //           .VITE_APP_STATUS_VALIDEE_MODIFICATION_AVEC_VALIDATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_ANNULE_DEMANDE_CREATION_EPF &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env
      //           .VITE_APP_ID_STATUS_ANNULE_DEAMNDE_MODIFICATION_EPF &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env
      //           .VITE_APP_ID_STATUS_ANNULE_DEAMNDE_CREATION_EPF_EXISTANT &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_REFUSEE_EPF &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_REFUSEE_MODIFICATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_REFUSEE_EPF_EXISTANT &&
      //       // elem?.id_etat_dossier_md5 !==
      //       //   import.meta.env.VITE_APP_ID_STATUS_BROUILLON_HOMOLOGATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_ANNULEE_HOMOLOGATION &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON_CREATION_SESSION_FORMATION_HOMOLOGUEE &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_ANNULEE_CREATION_SESSION_FORMATION_HOMOLOGUEE &&
      //       elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_BROUILLON_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE_ET_CONINUE &&
      //         elem?.id_etat_dossier_md5 !==
      //         import.meta.env.VITE_APP_ID_STATUS_ANNULEE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE_ET_CONINUE

      //   );
      // } else {
      filteredData = data.aaData;
      // }
      // debugger

      setDataSource(filteredData);
      // let brouillon = data?.aaData.filter(
      //   (elem) =>
      //     elem.etat === "Brouillon" &&
      //     elem.affaire_id_contrat === import.meta.env.VITE_ID_LIGNE_PRODUIT
      // );
      // const brouillinAnnexe = data?.aaData.filter(
      //   (elem) =>
      //     elem.etat === "Brouillon" &&
      //     elem.affaire_id_contrat ===
      //       import.meta.env.VITE_ID_LIGNE_PRODUIT_ANNEXE
      // );
      // if (brouillinAnnexe.length > 0) {
      //   sessionStorage.setItem(
      //     "id_affaire_annexe",
      //     brouillinAnnexe[0]?.affaire_id
      //   );
      //   setBrouillon(brouillinAnnexe);
      //   setIsLoading(false);
      // }
      // if (brouillon.length > 0) {
      //   sessionStorage.setItem("id_affaire", brouillon[0]?.affaire_id);
      //   setBrouillon(brouillon);
      //   setIsLoading(false);
      // }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      notification.error({
        message: t("Erreur"),
        description:
          error?.response?.data?.message ||
          "Une interruption est survenue lors de la récupération des données. Veuillez réessayer.",
      });
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Card title="Liste des sessions de formation" bordered={false}>
        <Table
          locale={{ emptyText: t("Aucune donnée") }}
          // loading={loading}
          columns={columns}
          dataSource={dataSource}
          className="ant-border-space"
          style={{ overflowX: "auto" }}
          pagination={true}
        />
      </Card>

      <Modal
        title="Liste des apprenants"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleAddParticipant}
        okButtonProps={{ disabled: selectedRowKeys.length === 0 }}
      >
        <Table
          rowSelection={{
            selectedRowKeys,
            onChange: (keys) => setSelectedRowKeys(keys),
          }}
          columns={[
            { title: "Nom", dataIndex: "surname_ar" },
            { title: "Prénom", dataIndex: "name_ar" },
            { title: "Nationnalité", dataIndex: "nationality" },
            { title: "Cin / Passeport", dataIndex: "passport" },
          ]}
          dataSource={demandeurs}
          rowKey="id"
          size="small"
        />
      </Modal>
      <ModalUploadPVCertifs
        openModal={openModal}
        setOpenModal={setOpenModal}
        pv={pv}
        setPv={setPv}
      />

      <Modal
        open={confirmAbandonVisible}
        onCancel={() => setConfirmAbandonVisible(false)}
        onOk={confirmRemove}
        title="Confirmation"
        okText="Abandonner"
      >
        <p>
          Êtes-vous sûr de vouloir abandonner cet apprenant ? Cette action est
          irréversible.
        </p>
        <Row gutter={16}>
          <Col lg={24} md={24}>
            <Form.Item
              label={t("Motif")}
              name="motif"
              rules={[
                {
                  required: true,
                  message: t("Veuillez remplir ce champ."),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default CoursSession;
